// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__kNrEt","singleAction":"styles_singleAction__pK-+A","ui-spin":"styles_ui-spin__Rcchj"};